import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

import { select, Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { map, takeUntil, filter } from 'rxjs/operators';

import * as fromAuth from '../../reducers'

import * as account from '../../actions/account';

import { ContainerBase } from '../../../core/base/container-base'
import { AccountValidationResult } from '../../models/account';

@Component({
  selector: 'app-verify-email-container',
  templateUrl: './verify-email-container.component.html'
})
export class VerifyEmailContainer extends ContainerBase implements OnInit {
  public userId$: Observable<string>;
  public verifyEmailWorking$: Observable<boolean>;
  public verifyEmailSuccess$: Observable<boolean>;
  public verifyEmailError$: Observable<Error>;
  public accountValidationResult$: Observable<AccountValidationResult>;

  constructor(private store: Store<fromAuth.State>, private route: ActivatedRoute) {
    super();

    this.route.params.pipe(
      takeUntil(this.destroyed$),
      filter(params => params && params['userId']),
      map(params => params['userId'])
    ).subscribe((userId) => {
      if (userId.length !== 24) {
        // Invalid userId
        this.store.dispatch(new account.UserVerifyEmailFailed(new Error('verify-email.user-not-found')))
      } else {
        this.store.dispatch(new account.UserVerifyEmail(userId))
      }
    })

    this.verifyEmailWorking$ = this.store.pipe(
      select(fromAuth.isVerifyEmailWorking),
      takeUntil(this.destroyed$)
    )

    this.verifyEmailSuccess$ = this.store.pipe(
      select(fromAuth.isVerifyEmailSuccess),
      takeUntil(this.destroyed$)
    )

    this.verifyEmailError$ = this.store.pipe(
      select(fromAuth.getVerifyEmailError),
      takeUntil(this.destroyed$)
    )

    this.accountValidationResult$ = this.store.pipe(
      select(fromAuth.getAccountValidationResult),
      takeUntil(this.destroyed$)
    )
  }

  public ngOnInit(): void {

  }

  public verifyEmail(userId: string): void {
    this.store.dispatch(new account.UserVerifyEmail(userId))
  }
}
